<template>
  <div style="width:100%;height:100%;">
    <autofillformList
      v-if="autofillformFlag" :autofillformFlag="autofillformFlag" @changeView = "changeView" @showItem = "showItem"
    />
    <autofillformCreate
      v-else :autofillformFlag="autofillformFlag" @changeView = "changeView" v-bind:transParams="transParams"
    />
  </div>
</template>

<script>
import '@/assets/scss/base/module/system.scss'
import autofillformList from './autofillformList/index'
import autofillformCreate from './autofillformCreate/index'
export default {
  name: '',
  data() {
    return {
      autofillformFlag: true,
      transParams: {}
    }
  },
  props: [],
  components: {
    autofillformList, autofillformCreate
  },
  mounted() {},
  methods: {
    changeView(flag) {
      this.autofillformFlag = flag
      this.transParams = {
        readOnly: false,
        item: {
          id: '',
          name: '',
          refApp: '',
          ruleFrom: '0',
          formItemList: []
        }
      }
    },
    showItem(transParams, flag) {
      if (transParams.readOnly !== undefined) {
        this.transParams.readOnly = transParams.readOnly
      }
      this.transParams = transParams
      this.autofillformFlag = flag
    }
  }
}
</script>
